<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>
      <div class="row">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => 'Titulo'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Container.vue